import {SubjectList} from "./SubjectList";
import SubjectEdit from "./SubjectEdit";
import {SubjectCreate} from "./SubjectCreate";

export default {
    list: SubjectList,
    create: SubjectCreate,
    edit: SubjectEdit
};
